import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReportPhishing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.89943 9.27993L9.87543 10.2146M12.8826 9.02976C12.8826 12.9422 7.99996 14.3613 7.99996 14.3613C7.99996 14.3613 3.11795 12.9428 3.11795 9.02976C3.11795 5.11664 2.93996 4.81091 3.33196 4.43478C3.72463 4.05808 7.35996 2.84131 7.99996 2.84131C8.64063 2.84131 12.2753 4.05494 12.6673 4.43478C13.06 4.81404 12.8826 5.11728 12.8826 9.02976ZM7.5807 6.05631C8.65136 6.05631 9.51943 6.88947 9.51943 7.91692C9.51943 8.94444 8.65136 9.77696 7.5807 9.77696C6.51073 9.77696 5.64274 8.94444 5.64274 7.91692C5.64274 6.88947 6.51073 6.05631 7.5807 6.05631Z",
		stroke: "#596180",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgReportPhishing;
